module.exports = {"210403002":"东洲街道","210403004":"搭连街道","210403005":"龙凤街道","210403006":"新屯街道","210403007":"万新街道","210403008":"老虎台街道","210403012":"章党街道","210403103":"章党镇","210403104":"哈达镇","210403202":"碾盘乡","210403215":"兰山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210403.json
// module id = 621
// module chunks = 0